const Bolt = ({ size = 24, color = "var(--primary-text-color)", tooltip = { content: '', position: '' } }) => {

    const tooltipProps = tooltip.content
        ? {
            'data-tooltip-content': tooltip.content,
            'data-tooltip-position': tooltip.position,
        }
        : {};

    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            height={`${size}px`}
            width={`${size}px`}
            viewBox="0 -960 960 960"
            fill={color}
            {...tooltipProps}
        >
            <path d="M422-232 616-520H462l36-208-194 288h154zM320-80l40-280H160l360-520h80l-40 320h240L400-80z" />
        </svg>
    )
}

export default Bolt;
